import { defineMessages } from 'react-intl';

const messages = defineMessages({
  columns: {
    id: 'Colunas',
    defaultMessage: 'Colunas',
  },
  slidesToShow: {
    id: 'Slides para mostrar',
    defaultMessage: 'Slides para mostrar',
  },
  autoplay: {
    id: 'Reprodução automática',
    defaultMessage: 'Reprodução automática',
  },
  autoplaySpeed: {
    id: 'Velocidade da reprodução automática (ms)',
    defaultMessage: 'Velocidade da reprodução automática (ms)',
  },
  speed: {
    id: 'Velocidade da transição (ms)',
    defaultMessage: 'Velocidade da transição (ms)',
  },
  infinite: {
    id: 'Loop infinito',
    defaultMessage: 'Loop infinito',
  },
  pauseOnHover: {
    id: 'Pausar ao passar o mouse',
    defaultMessage: 'Pausar ao passar o mouse',
  },
  showDots: {
    id: 'Mostrar pontos indicadores',
    defaultMessage: 'Mostrar pontos indicadores',
  },
  showDate: {
    id: 'Mostrar data',
    defaultMessage: 'Mostrar data',
  },
  dateFormat: {
    id: 'Formato da data',
    defaultMessage: 'Formato da data',
  },
});

export const servicosSchemaEnhancer = ({ schema, formData, intl }) => {
  if (formData?.variation === 'servicos') {
    const properties = {
      ...schema.properties,
      columns: {
        title: intl.formatMessage(messages.columns),
        choices: [
          ['one', '1'],
          ['two', '2'],
          ['three', '3'],
          ['four', '4'],
        ],
        default: 'four',
      },
    };

    const fieldsets = schema.fieldsets;
    const servicoFieldset = {
      id: 'services',
      title: 'Serviços',
      fields: ['columns'],
    };

    fieldsets.push(servicoFieldset);
    schema = {
      ...schema,
      properties: properties,
      fieldsets: fieldsets,
    };
  }
  return schema;
};

export const carroselSchemaEnhancer = ({ schema, formData, intl }) => {
  if (formData?.variation === 'carousel') {
    const properties = {
      ...schema.properties,
      autoplay: {
        title: intl.formatMessage(messages.autoplay),
        type: 'boolean',
        default: true,
      },
      autoplaySpeed: {
        title: intl.formatMessage(messages.autoplaySpeed),
        type: 'number',
        default: 4000,
        minimum: 1000,
        maximum: 10000,
      },
      speed: {
        title: intl.formatMessage(messages.speed),
        type: 'number',
        default: 1000,
        minimum: 300,
        maximum: 3000,
      },
      infinite: {
        title: intl.formatMessage(messages.infinite),
        type: 'boolean',
        default: true,
      },
      pauseOnHover: {
        title: intl.formatMessage(messages.pauseOnHover),
        type: 'boolean',
        default: true,
      },
      showDots: {
        title: intl.formatMessage(messages.showDots),
        type: 'boolean',
        default: true,
      },
    };

    const fieldsets = schema.fieldsets;
    const carouselFieldset = {
      id: 'carousel',
      title: 'Configurações do Carrossel',
      fields: [
        'autoplay',
        'autoplaySpeed',
        'speed',
        'infinite',
        'pauseOnHover',
        'showDots',
      ],
    };

    fieldsets.push(carouselFieldset);
    schema = {
      ...schema,
      properties: properties,
      fieldsets: fieldsets,
    };
  }
  return schema;
};
